import { useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";

// Single

type Permissions = {
  tenant_create: false;
  tenant_delete: false;
  tenant_list: false;
  user_manage: false;
  content_manage: false;
  maintenance: false;
};

export const getInstancePermissions = () => {
  return {
    queryKey: ["instance-instance-permissions"],
    queryFn: async () => {
      return (await getRanaApiV1().InstanceUsersApi.instancePermissions({})) as Permissions;
    },
  };
};

export const useInstancePermissionsQuery = () => {
  return useQuery(getInstancePermissions());
};

export const useInstancePermissions = () => {
  const instancePermissionsQuery = useInstancePermissionsQuery();
  const permissions: Partial<Permissions> = instancePermissionsQuery.data ?? {};
  return {
    permissionsLoading: instancePermissionsQuery.isLoading,
    canCreateTenant: permissions["tenant_create"] ?? false,
    canDeleteTenant: permissions["tenant_delete"] ?? false,
    canListTenant: permissions["tenant_list"] ?? false, // Can list tenants user is not a part of
    canManageUser: permissions["user_manage"] ?? false,
    canManageContent: permissions["content_manage"] ?? false,
    canDoMaintenance: permissions["maintenance"] ?? false,
  };
};
